import React from 'react';

const money = (value) => `$${Number(value || 0).toFixed(2)}`;

// Itemized card charge shown before payment, from a server `breakdown`
// ({ baseAmount, processingFee, totalAmount }). Renders nothing when there's no
// processing fee, since the total is then just the listed price.
const PaymentBreakdown = ({ breakdown, baseLabel = 'Amount' }) => {
  if (!breakdown || !(Number(breakdown.processingFee) > 0)) return null;

  return (
    <div className="mb-4 rounded-lg border border-gray-200 bg-gray-50 px-4 py-3 text-sm">
      <div className="flex justify-between text-gray-700">
        <span>{baseLabel}</span>
        <span>{money(breakdown.baseAmount)}</span>
      </div>
      <div className="flex justify-between text-gray-700 mt-1">
        <span>Card processing fee</span>
        <span>{money(breakdown.processingFee)}</span>
      </div>
      <div className="flex justify-between font-semibold text-gray-900 mt-2 pt-2 border-t border-gray-200">
        <span>Total</span>
        <span>{money(breakdown.totalAmount)}</span>
      </div>
    </div>
  );
};

export default PaymentBreakdown;
